import { render, staticRenderFns } from "./newEditAgenda.vue?vue&type=template&id=53019a0b"
import script from "./newEditAgenda.vue?vue&type=script&lang=js"
export * from "./newEditAgenda.vue?vue&type=script&lang=js"
import style0 from "./newEditAgenda.vue?vue&type=style&index=0&id=53019a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports